(function () {
  var cursor = document.querySelector('.cursor');
  var canvas = document.getElementById('cursor-canvas');
  var ctx = canvas ? canvas.getContext('2d') : null;
  var particles = [];
  var animating = false;
  var config = {};

  var hoverSelector = 'a, button, [role="button"], input, select, textarea, label, .btn';

  function getConfig() {
    return Object.assign({
      enableCustomCursor: true,
      enableParticles: true,
      cursorSize: 10,
      cursorHoverSize: 36,
      cursorColor: '#ffffff',
      blendMode: 'difference',
      particleColor: '#FFD700',
      particleCount: 3,
      particleSizeMin: 4,
      particleSizeMax: 12,
      particleSpeed: 3,
      particleFadeSpeed: 3,
      particleShape: 'star'
    }, window.campaignCursor || {});
  }

  function applyCursor() {
  config = getConfig();
  if (!config.enableCustomCursor) return;
  if (!cursor) return;

  if (config.cursorImage) {
    cursor.style.width = config.cursorImageSize + 'px';
    cursor.style.height = config.cursorImageSize + 'px';
    cursor.style.backgroundImage = 'url("' + config.cursorImage + '")';
    cursor.style.backgroundSize = 'contain';
    cursor.style.backgroundRepeat = 'no-repeat';
    cursor.style.backgroundPosition = 'center';
    cursor.style.backgroundColor = 'transparent';
    cursor.style.borderRadius = '0';
    cursor.style.mixBlendMode = '';
  } else {
    cursor.style.width = config.cursorSize + 'px';
    cursor.style.height = config.cursorSize + 'px';
    cursor.style.backgroundImage = '';
    cursor.style.backgroundColor = config.cursorColor;
    cursor.style.borderRadius = '50%';
    if (config.blendMode && config.blendMode !== 'normal') {
      cursor.style.mixBlendMode = config.blendMode;
    } else {
      cursor.style.mixBlendMode = '';
    }
  }
}


  // Hide cursor on touch devices
  if ('ontouchstart' in window && navigator.maxTouchPoints > 0) {
    if (cursor) cursor.style.display = 'none';
    if (canvas) canvas.style.display = 'none';
    return;
  }

  applyCursor();


  // Re-apply when theme editor updates the section
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-section-type="campaign-cursor"], script')) {
      applyCursor();
    }
  });

  document.addEventListener('mousemove', function (e) {
    if (cursor) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      cursor.classList.remove('cursor--hidden');
    }
    spawnParticles(e.clientX, e.clientY);
  });

  document.addEventListener('mouseleave', function () {
    if (cursor) cursor.classList.add('cursor--hidden');
  });

  document.addEventListener('mouseenter', function () {
    if (cursor) cursor.classList.remove('cursor--hidden');
  });

  document.addEventListener('mouseover', function (e) {
    if (!cursor) return;
    if (e.target.closest(hoverSelector)) {
      if (config.cursorHoverImage) {
        cursor.style.backgroundImage = 'url("' + config.cursorHoverImage + '")';
        var hoverSize = config.cursorHoverImageSize || config.cursorImageSize;
        cursor.style.width = hoverSize + 'px';
        cursor.style.height = hoverSize + 'px';
      } else {
        var hoverSize = config.cursorImage ? config.cursorImageSize * 1.2 : config.cursorHoverSize;
        cursor.style.width = hoverSize + 'px';
        cursor.style.height = hoverSize + 'px';
      }
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!cursor) return;
    if (e.target.closest(hoverSelector)) {
      if (config.cursorHoverImage && config.cursorImage) {
        cursor.style.backgroundImage = 'url("' + config.cursorImage + '")';
      }
      var defaultSize = config.cursorImage ? config.cursorImageSize : config.cursorSize;
      cursor.style.width = defaultSize + 'px';
      cursor.style.height = defaultSize + 'px';
    }
  });

  if (!canvas || !ctx) return;

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function spawnParticles(x, y) {
    if (!config.enableParticles) return;
    for (var i = 0; i < config.particleCount; i++) {
      var speed = random(0.5, config.particleSpeed);
      var angle = random(0, Math.PI * 2);
      particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - random(1, 2),
        size: random(config.particleSizeMin, config.particleSizeMax),
        opacity: 1,
        rotation: random(0, Math.PI * 2),
        rotationSpeed: random(-0.1, 0.1)
      });
    }
    if (!animating) {
      animating = true;
      requestAnimationFrame(loop);
    }
  }

  function drawStar(x, y, size, rotation) {
    var spikes = 4;
    var outer = size;
    var inner = size * 0.4;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.beginPath();
    for (var i = 0; i < spikes * 2; i++) {
      var r = i % 2 === 0 ? outer : inner;
      var a = (Math.PI / spikes) * i;
      if (i === 0) ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r);
      else ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
    }
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function drawDiamond(x, y, size, rotation) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.beginPath();
    ctx.moveTo(0, -size);
    ctx.lineTo(size * 0.6, 0);
    ctx.lineTo(0, size);
    ctx.lineTo(-size * 0.6, 0);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function drawCircle(x, y, size) {
    ctx.beginPath();
    ctx.arc(x, y, size, 0, Math.PI * 2);
    ctx.fill();
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var fadeAmount = config.particleFadeSpeed * 0.02;

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.08;
      p.opacity -= fadeAmount;
      p.rotation += p.rotationSpeed;

      if (p.opacity <= 0) {
        particles.splice(i, 1);
        continue;
      }

      ctx.globalAlpha = p.opacity;
      ctx.fillStyle = config.particleColor;
      var half = p.size / 2;

      if (config.particleShape === 'circle') {
        drawCircle(p.x, p.y, half);
      } else if (config.particleShape === 'diamond') {
        drawDiamond(p.x, p.y, half, p.rotation);
      } else {
        drawStar(p.x, p.y, half, p.rotation);
      }
    }

    ctx.globalAlpha = 1;

    if (particles.length > 0) {
      requestAnimationFrame(loop);
    } else {
      animating = false;
    }
  }
  // Confetti
  (function () {
    var conf = window.campaignConfetti;
    if (!conf || !conf.enabled) return;

    var confCanvas = document.getElementById('confetti-canvas');
    if (!confCanvas) return;

    var confCtx = confCanvas.getContext('2d');
    var pieces = [];
    var confAnimating = false;

    function resizeConf() {
      confCanvas.width = window.innerWidth;
      confCanvas.height = window.innerHeight;
    }
    resizeConf();
    window.addEventListener('resize', resizeConf);

    function randBetween(min, max) {
      return Math.random() * (max - min) + min;
    }

    function pickShape() {
      var shape = conf.shape || 'rectangle';
      if (shape === 'mixed') {
        return Math.random() > 0.5 ? 'rectangle' : 'circle';
      }
      return shape;
    }

    function makePiece(x, y, vx, vy) {
      var colors = conf.colors && conf.colors.length ? conf.colors : ['#ff6b6b', '#ffd93d', '#6bcb77'];
      var sizeMultiplier = conf.size ? conf.size * 0.5 : 1;
      return {
        x: x,
        y: y,
        w: randBetween(8, 16) * sizeMultiplier,
        h: randBetween(4, 8) * sizeMultiplier,
        shape: pickShape(),
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: randBetween(0, Math.PI * 2),
        rotationSpeed: randBetween(-0.08, 0.08),
        vx: vx,
        vy: vy,
        opacity: 1
      };
    }


    function burst() {
      var count = conf.count || 150;
      var style = conf.style || 'rain';
      var w = confCanvas.width;
      var h = confCanvas.height;

      for (var i = 0; i < count; i++) {
        var p;

        if (style === 'cannon') {
          // Alternates between left and right bottom corners
          if (i % 2 === 0) {
            p = makePiece(
              randBetween(0, w * 0.1),
              h,
              randBetween(4, 10),
              randBetween(-18, -10)
            );
          } else {
            p = makePiece(
              randBetween(w * 0.9, w),
              h,
              randBetween(-10, -4),
              randBetween(-18, -10)
            );
          }
          

        } else if (style === 'cannon_center') {
          p = makePiece(
            randBetween(w * 0.4, w * 0.6),
            h,
            randBetween(-10, 10),
            randBetween(-18, -10)
          );

        } else if (style === 'burst') {

          var angle = randBetween(0, Math.PI * 2);
          var speed = randBetween(4, 14);
          p = makePiece(
            w / 2,
            h / 2,
            Math.cos(angle) * speed,
            Math.sin(angle) * speed
          );

        } else if (style === 'sides') {
          if (i % 2 === 0) {
            p = makePiece(
              0,
              randBetween(h * 0.1, h * 0.6),
              randBetween(4, 10),
              randBetween(-6, 4)
            );
          } else {
            p = makePiece(
              w,
              randBetween(h * 0.1, h * 0.6),
              randBetween(-10, -4),
              randBetween(-6, 4)
            );
          }

        } else {
          // rain — default
          p = makePiece(
            randBetween(0, w),
            randBetween(-200, -10),
            randBetween(-2, 2),
            randBetween(3, 7)
          );
        }

        pieces.push(p);
      }

      if (!confAnimating) {
        confAnimating = true;
        requestAnimationFrame(confLoop);
      }
    }

    function drawPiece(p) {
      confCtx.save();
      confCtx.globalAlpha = p.opacity;
      confCtx.fillStyle = p.color;
      confCtx.translate(p.x, p.y);
      confCtx.rotate(p.rotation);

      if (p.shape === 'circle') {
        confCtx.beginPath();
        confCtx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
        confCtx.fill();
      } else {
        confCtx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      }

      confCtx.restore();
    }

    function confLoop() {
      confCtx.clearRect(0, 0, confCanvas.width, confCanvas.height);

      for (var i = pieces.length - 1; i >= 0; i--) {
        var p = pieces[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.12;
        p.vx *= 0.99;
        p.rotation += p.rotationSpeed;

        if (p.y > confCanvas.height * 0.75) {
          p.opacity -= 0.02;
        }

        if (p.opacity <= 0 || p.y > confCanvas.height) {
          pieces.splice(i, 1);
          continue;
        }

        drawPiece(p);
      }

      if (pieces.length > 0) {
        requestAnimationFrame(confLoop);
      } else {
        confAnimating = false;
      }
    }

    setTimeout(burst, conf.delay != null ? conf.delay : 800);
  })();

})();